import { BUSINESS_UNITS } from '@common/constants/BusinessUnits';
import { SERVICES } from '@common/constants/Services';
import { IBusinessUnitModel } from '@common/models/Businesses/BusinessUnit';

import { ChatConfig, findConfigKey, getConfigValue } from '..';

export const ChatRulesConstants: ChatConfig<boolean> = {
	DEFAULT: false,
	CONFIG: {
		[`${SERVICES.ACADEMY}-${BUSINESS_UNITS.STUDY_ACADEMY}`]: true,
		[`${SERVICES.LYCEUM}-${BUSINESS_UNITS.STUDY_ACADEMY_HIGH_SCHOOL}`]: true,
		[`${SERVICES.LYCEUM}-${BUSINESS_UNITS.STUDY_ACADEMY_HIGH_SCHOOL_ODESSA}`]: true,
	},
};

/**
 * A function that checks whether chat rules should be displayed
 * for a combination of serviceId and business unit.
 *
 * @param {number} serviceId - The ID representing the selected service.
 * @param {IBusinessUnitModel[]} businessUnits - List of business units.
 * @returns {boolean} - Returns true if you need to show chat rules and false if not.
 */
export function getChatRules(serviceId: number, businessUnits: IBusinessUnitModel[]): boolean {
	return getConfigValue(ChatRulesConstants, serviceId, businessUnits);
}

/**
 * A function to retrieve the matching service and business unit for chat rules.
 *
 * @param {number} serviceId - The ID representing the selected service.
 * @param {IBusinessUnitModel[]} businessUnits - List of business units.
 * @returns {{ serviceId: number; businessUnitId: number } | null} - Returns
 * the matching service and business unit or null.
 */
export function getChatRulesDetails(
	serviceId: number,
	businessUnits: IBusinessUnitModel[],
): { serviceId: number; businessUnitId: number } | null {
	return findConfigKey(ChatRulesConstants, serviceId, businessUnits);
}
